import { h } from 'preact';
import { useRef } from 'preact/hooks';
import clsx from 'clsx';
import { Player } from '@lottiefiles/react-lottie-player';
import { useThreekit } from '../threekit-context';
import ThreekitIcons from '../components/threekit-icons';

const RandomizeButton = () => {
  const {
    productTag,
    configurator,
    configuration,
    setConfiguration,
    products,
    darkMode,
    backgroundColor,
    getBackgroundColorFromSelectedVariant,
    lottie,
  } = useThreekit();
  const lottiePlayerRef = useRef(null);
  const variantBackgroundColor = getBackgroundColorFromSelectedVariant();
  const randomConfigurationAttribute = { '3D Animations': 'Shuffle' };
  // Get all Variants
  const allVariantConfigs = products.flatMap((product) =>
    product.variants.edges
      .filter(
        (variant) =>
          variant.node.configurationEnabled
          && variant.node.configuration
          && !variant.node.disableInCustomizer
          && variant.node.available,
      )
      .map((variant) => variant.node.configuration),
  );

  // Group variants by last key in the array
  const groupedVariants = Object.values(
    allVariantConfigs.reduce((acc, curr) => {
      // if a key contains Handle Material,
      // add it to the Handle Material group
      const name = curr['Handle Material']
        ? 'Handle Material'
        : Object.keys(curr).pop();

      acc[name] = acc[name] || [];
      acc[name].push(curr);
      return acc;
    }, {}),
  );

  const handleRandomize = async () => {
    let randomConfiguration = {};
    // Use the grouped variants
    groupedVariants.forEach((group) => {
      const randomIndex = Math.floor(Math.random() * group.length);
      const randomItem = group[randomIndex];
      randomConfiguration = { ...randomConfiguration, ...randomItem };
    });

    // Set the front and back handle colors to be the same
    randomConfiguration['Front Handle Color'] = randomConfiguration['Front Handle Color']
      || randomConfiguration['Back Handle Color'];

    randomConfiguration['Back Handle Color'] = randomConfiguration['Back Handle Color']
      || randomConfiguration['Front Handle Color'];

    setConfiguration({ ...configuration, ...randomConfiguration });
    await configurator.setConfiguration(randomConfigurationAttribute);
    await configurator.setConfiguration({
      'Handle Material': randomConfiguration['Handle Material'],
    });
    delete randomConfiguration['Handle Material'];
    await configurator.setConfiguration(randomConfiguration);
    lottiePlayerRef.current.setSeeker(0, true);
    lottiePlayerRef.current.play();
  };

  if (productTag === 'cstm:personalization' || productTag === 'cstm:service') {
    return;
  }

  // eslint-disable-next-line consistent-return
  return (
    <button onClick={() => handleRandomize()}>
      <span
        className={clsx('hidden laptop:flex h-[34px] overflow-hidden', {
          'text-white':
            (!darkMode && variantBackgroundColor?.isDark) || darkMode,
          'text-black': !darkMode && !variantBackgroundColor?.isDark,
        })}
        style={{
          backgroundColor:
            backgroundColor?.presetLightMode && variantBackgroundColor?.hex,
        }}
      >
        <Player
          src={lottie?.shuffle}
          ref={lottiePlayerRef}
          keepLastFrame={true}
          className="w-[160px]"
        />{' '}
      </span>
      <span
        className={clsx(
          'w-9 h-9 laptop:hidden flex items-center justify-center bg-primary-1 rounded-[2px] bg-opacity-40',
          { 'text-white': darkMode },
        )}
        style={{
          backgroundColor:
            backgroundColor?.presetLightMode && variantBackgroundColor?.hex,
        }}
      >
        <ThreekitIcons type="shuffleIconMobile" className="text-white" />
      </span>
    </button>
  );
};

export default RandomizeButton;
